import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ResetPasswordPage() {

    const navigate = useNavigate();

    const [ newPassword, setNewPassword ] = useState('');
    const [ confirmPassword, setConfirmPassword ] = useState('');

    const [ confirmCheck, setConfirmCheck ] = useState(false);

    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        if (newPassword && confirmPassword) setConfirmCheck(newPassword === confirmPassword);
        else setConfirmCheck(false);
    }, [newPassword, confirmPassword]);

    const handleSubmit = () => {
        if(loading) return;
        if (!confirmCheck) return;
        if (newPassword !== confirmPassword) {
            alert("새 비밀번호와 확인 비밀번호가 일치하지 않습니다.");
            return;
        }

        setLoading(true);
        axios.post('/api/manage/reset', { password: newPassword }, {timeout: process.env.REACT_APP_API_TIMEOUT})
            .then((res) => {
                alert("비밀번호가 성공적으로 재설정되었습니다.");
                navigate('/');
            })
            .catch((err) => {
                console.error("비밀번호 재설정 실패:", err.message);
                alert("비밀번호 재설정 실패");
                setNewPassword('');
                setConfirmPassword('');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div style={{ maxWidth: 800, margin: "40px auto" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>비밀번호 재설정</h2>
            <input value={newPassword} onChange={(e) => setNewPassword(e.target.value)} type="password" placeholder="새 비밀번호" style={{ width: "calc(100% - 20px)", padding: 10, marginBottom: 16, borderRadius: 4, border: "1px solid #ccc" }} />
            <input value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} type="password" placeholder="새 비밀번호 확인" style={{ width: "calc(100% - 20px)", padding: 10, marginBottom: 24, borderRadius: 4, border: "1px solid #ccc" }} />
            {confirmCheck ? null : <span style={{fontSize: '10pt', marginBottom: 20, color: 'red'}}>비밀번호가 일치하지 않습니다.</span>}
            <button onClick={handleSubmit} style={{ width: "100%", padding: 12, backgroundColor: confirmCheck ? "#007bff" : "#aaa", color: "white", border: "none", borderRadius: 4, cursor: "pointer" }}>
                {loading ? '로딩중...' : '비밀번호 재설정'}
            </button>
        </div>
    );
}